import Image from 'next/image';
import type { FC } from 'react';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
interface Props {
  description: string;
}
const SubscriptionBuyDescription: FC<Props> = ({
  description
}) => {
  const items = description?.split('\n') ?? [];
  return <div className="hidden rounded-2xl bg-white px-6 py-4 sm:block " data-sentry-component="SubscriptionBuyDescription" data-sentry-source-file="SubscriptionBuyDescription.tsx">
      <div className="mb-4 font-bold">با این اشتراک چه امکاناتی خواهید داشت؟</div>
      {items.map(item => <li className="mb-3 flex flex-row items-center" key={item}>
          {item.includes('-') ? <Image width={16} height={16} src={`${FILE_BROWSER_URL}/img/exclude.webp`} className="ml-2 w-[16px] min-w-[16px] text-greenThree" alt="cancel" /> : <Image width={16} height={16} src={`${FILE_BROWSER_URL}/img/include.webp`} className="ml-2 w-[16px] min-w-[16px] text-greenThree" alt="accept" />}
          <span className="md:text-md text-sm text-blackFive">{item.replace('-', '')}</span>
        </li>)}
    </div>;
};
export default SubscriptionBuyDescription;